import { ColorType } from './types/color-type'
import { TPlanSummary } from './cms-types'

export enum PlanSlug {
  PHONE = 'virtual-office-phone',
  SCAN_LITE = 'Virtual-Office-London',
  SCAN_PRO = 'Virtual-Office-London-Mail-Forwarding',
}

export enum PlanLinks {
  PHONE = 'virtual-office-phone',
  SCAN_LITE = 'virtual-office-london-old-street',
  SCAN_PRO = 'virtual-office-forward',
}
export const planOrder = [PlanSlug.SCAN_LITE, PlanSlug.SCAN_PRO, PlanSlug.PHONE]

export enum AddonSlug {
  'Virtual-Office-London-Mail-Forwarding' = PlanSlug.SCAN_PRO,
  DIRECTORS_SERVICE_ADDRESS = 'addon-directors-service-address',
  VIRTUAL_OFFICE_PHONE = 'addon-virtual-office-phone',
  TIDE_BUSINESS_BANKING = 'addon-tide-business-banking',
  CRUNCH = 'CRUNCH',
  INTRODUCTION_TO_AN_ACCOUNTANT = 'addon-introduction-to-an-accountant',
}

export const hideAddonsMapping = {
  [PlanSlug.PHONE]: true,
  [PlanSlug.SCAN_LITE]: false,
  [PlanSlug.SCAN_PRO]: false,
}

export const planToParent = {
  [PlanSlug.SCAN_PRO]: PlanSlug.SCAN_LITE,
}

export function getParentPlan(planSlug: PlanSlug, plans: TPlanSummary[]) {
  if (planToParent[planSlug]) {
    return plans.find((v) => v.slug === planToParent[planSlug])
  }
}

export const addonToProductMapping = {
  [PlanSlug.PHONE]: AddonSlug.VIRTUAL_OFFICE_PHONE,
  [PlanSlug.SCAN_LITE]: null,
  [PlanSlug.SCAN_PRO]: null,
}

export const planColors: Record<PlanSlug, ColorType> = {
  [PlanSlug.PHONE]: 'lavender',
  [PlanSlug.SCAN_LITE]: 'blue',
  [PlanSlug.SCAN_PRO]: 'purple2',
}
